const submissionPermissions = (action, permissions, institutionId, year) => {
  if (
    action === 'submission:viewSubmission' &&
    permissions[institutionId].some((item) =>
      [
        `DATAPOINTS_DEVELOPER_${year}`,
        `THE_STAFF_ACCESS_ALL_INSTITUTIONS_${year}`,
        `WUR_REPORTER_INTERIM_${year}`,
        `DATAPLUS_ADVANCED_${year}`,
        `DATAPLUS_COMPREHENSIVE_${year}`,
      ].includes(item),
    )
  ) {
    return true;
  }

  return false;
};

module.exports = {
  submissionPermissions,
};
